import React from "react";
import ProtectedSwagger from "../components/ProtectedSwagger";
import { services } from "../config/services";

const service = services.find((item) => item.route === "/common-face-models-api");

const CommonFaceModelsAPIDoc = () => (
    <ProtectedSwagger
        service={service}
        url={process.env.PUBLIC_URL + "/json/openapi/common-face-models-api.json"}
    />
);

export default CommonFaceModelsAPIDoc;
